import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-suggestionTemplate",
  "use": "icon-suggestionTemplate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-suggestionTemplate\"><path d=\"M682.666667 227.555556a113.777778 113.777778 0 0 1 113.777777 113.777777v558.762667a113.777778 113.777778 0 0 1-113.777777 113.777778H113.777778a113.777778 113.777778 0 0 1-113.777778-113.777778V341.333333a113.777778 113.777778 0 0 1 113.777778-113.777777h568.888889z m227.555555-227.555556a113.777778 113.777778 0 0 1 113.777778 113.777778v839.736889a56.888889 56.888889 0 0 1-56.888889 56.888889h-55.182222a56.888889 56.888889 0 0 1-56.888889-56.888889v-671.288889a113.777778 113.777778 0 0 0-113.777778-113.777778H56.888889a56.888889 56.888889 0 0 1-56.888889-56.888889V56.888889a56.888889 56.888889 0 0 1 56.888889-56.888889h853.333333zM398.222222 512a113.777778 113.777778 0 1 0 0 227.555556 113.777778 113.777778 0 0 0 0-227.555556z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/suggestionTemplate.svg
// module id = UGko
// module chunks = 78